import { render, staticRenderFns } from "./FeaturesTheApp.vue?vue&type=template&id=7f1c073a&scoped=true&"
import script from "./FeaturesTheApp.vue?vue&type=script&lang=js&"
export * from "./FeaturesTheApp.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesTheApp.vue?vue&type=style&index=0&id=7f1c073a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c073a",
  null
  
)

export default component.exports